// https://stackoverflow.com/a/8027444
const VALID_COLOR_REGEX = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0]{8}$)/i;

const isValidColor = (value: string) => !value || VALID_COLOR_REGEX.test(value);

export default isValidColor;
